<template>
    <div class="content work_wrapper">
        <v-row class="search_box">
            <v-col>
              <searchBar></searchBar>
            </v-col>
        </v-row>
        <div class="report_center_wrapper">
            <div class="flex_style betw mart24 marb24">
                <div class="md_title">{{title}}-报告分析</div>
                <div><v-btn @click="goDownload">下载</v-btn></div>
            </div>
            <div class="bread_route margbsm hand" @click="goBack">返回分析报告主页</div>
            <div class="center_content">
                <div class="md_title marb24">发送邮件</div>
                <v-row class="flex_style left simple_search">
                    <v-col xs="4" sm="10" class="input_box">
                        <v-text-field
                            label=""
                            v-model="email"
                            solo
                            hide-details
                            hide-selected
                        ></v-text-field>
                    </v-col>
                    <v-col xs="4" sm="2" class="right_btn hand">
                        <span class="text" @click="goResult">发送邮件</span>
                    </v-col> 
                </v-row>
            </div>
        </div>
    </div>        
</template>
<script>
import searchBar from "@/components/widgets/searchBar.vue";
import {mapActions} from 'vuex';
export default {
    data() {
        return {
            selectKeys: [],
            data: [

            ],
            email: '',
            reportId: '',
            title: ''
        }
    },
    components: {
        searchBar
    },
    created() {
        this.reportId = this.$route.params.id
        this.title = this.$route.query.title
    },
    methods: {
        ...mapActions('report',['sendReportEmail']),
        goDownload() {
            this.$router.push({
                path: '/report/download/'+ this.reportId,
                query: {
                    title: this.title
                }
            })
        },
        goBack() {
            this.$router.push({
                path: '/report'
            })
        },
        goResult() {
            let data = {
                url: this.reportId,
                data1: {
                    params: {
                        email: this.email
                    }
                }
            }
            let _this = this 
            this.sendReportEmail({data: data,handle(res) {
                if(res.success) {
                    _this.$message({
                        type: 'success',
                        message: res.message
                    })
                }else {
                    _this.$message({
                        type: 'error',
                        message: res.message || '发送失败'
                    }) 
                }
            }})
        }
    }
}
</script>